export const VENUE = {
  name: 'Bowling Tres Aguas',
  shortName: 'Tres Aguas',
  city: 'Alcorcón · Madrid',
  address: 'Avda. San Martín de Valdeiglesias, 24',
  postalCode: '28922',
  phone: '914 400 338',
  phoneHref: 'tel:+34914400338',
  email: 'info@bowlingtresaguas.com',
  officialUrl: 'https://bowlingtresaguas.com/',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Bowling%20Tres%20Aguas%2C%20Avda.%20San%20Mart%C3%ADn%20de%20Valdeiglesias%2024%2C%2028922%20Alcorc%C3%B3n%2C%20Madrid',
  coordinates: { lat: 40.3582135, lng: -3.8332489 },
};

export const EXPERIENCES = [
  {
    id: 'bowling',
    label: 'Bolos',
    title: 'La revancha empieza en la pista.',
    description: 'Partidas para venir a competir, celebrar un strike o simplemente echar la tarde con tu gente.',
    image: './venue/venue-main.jpg',
    alt: 'Pistas de bowling iluminadas en Bowling Tres Aguas',
    status: 'Tarifas publicadas',
    tone: 'cyan',
  },
  {
    id: 'billiards',
    label: 'Billar',
    title: 'Otra forma de bajar el ritmo.',
    description: 'La zona de billar aparece en fichas públicas del local. Modalidades, disponibilidad y tarifa: mejor confirmarlas en recepción.',
    image: './venue/billiards-atmosphere.png',
    alt: 'Mesa de billar en un ambiente de ocio nocturno',
    status: 'Confirmar tarifa en local',
    tone: 'lime',
  },
  {
    id: 'arcade',
    label: 'Arcade',
    title: 'Un pique más antes de irte.',
    description: 'Máquinas y juegos para completar el plan. El catálogo concreto puede cambiar, así que lo dejamos preparado para actualizar.',
    image: './venue/arcade-atmosphere.png',
    alt: 'Zona de máquinas arcade iluminadas junto a pistas de bowling',
    status: 'Catálogo por confirmar',
    tone: 'coral',
  },
  {
    id: 'kids',
    label: 'Zona kids',
    title: 'Plan familiar sin mirar el reloj.',
    description: 'La web oficial mantiene una zona Funny Kids y promociones de parque cumple. Consulta el protocolo y la disponibilidad del día.',
    image: './venue/kids-zone.jpg',
    alt: 'Zona infantil colorida de Bowling Tres Aguas',
    status: 'Consultar protocolo',
    tone: 'violet',
  },
];

export const PRICE_DAYS = [
  { id: 'lunes', label: 'LUN', name: 'Lunes', group: 'weekday' },
  { id: 'martes', label: 'MAR', name: 'Martes', group: 'weekday' },
  { id: 'miercoles', label: 'MIÉ', name: 'Miércoles', group: 'weekday' },
  { id: 'jueves', label: 'JUE', name: 'Jueves', group: 'weekday' },
  { id: 'viernes', label: 'VIE', name: 'Viernes', group: 'weekend' },
  { id: 'sabado', label: 'SÁB', name: 'Sábado', group: 'weekend' },
  { id: 'domingo', label: 'DOM', name: 'Domingo', group: 'weekend' },
];

const STANDARD_COMBOS = [
  {
    id: 'combo-1',
    name: 'Combo 1',
    title: '1 partida',
    description: 'bebida + alquiler de calzado',
    weekdayPrice: '7,60 €',
    weekendPrice: '9,40 €',
  },
  {
    id: 'combo-2',
    name: 'Combo 2',
    title: '2 partidas',
    description: 'bebida + alquiler de calzado',
    weekdayPrice: '11,00 €',
    weekendPrice: '14,20 €',
  },
  {
    id: 'combo-3',
    name: 'Combo 3',
    title: '3 partidas',
    description: 'bebida + alquiler de calzado',
    weekdayPrice: '11,40 €',
    weekendPrice: '—',
  },
];

export function getPricingForDay(dayId) {
  const day = PRICE_DAYS.find((entry) => entry.id === dayId) || PRICE_DAYS[0];
  return {
    ...day,
    note: day.group === 'weekday'
      ? day.id === 'martes' || day.id === 'miercoles'
        ? 'El Combo 3 está publicado solo para martes y miércoles, sin vísperas ni festivos.'
        : 'Tarifa de lunes a jueves · no válida en vísperas ni festivos.'
      : 'Tarifa de viernes, fines de semana, vísperas y festivos.',
    combos: STANDARD_COMBOS.map((combo) => {
      const isComboThree = combo.id === 'combo-3';
      const comboThreeAvailable = day.id === 'martes' || day.id === 'miercoles';
      const available = !isComboThree || comboThreeAvailable;
      return {
        ...combo,
        available,
        price: isComboThree ? (comboThreeAvailable ? combo.weekdayPrice : 'No publicado') : day.group === 'weekday' ? combo.weekdayPrice : combo.weekendPrice,
      };
    }),
  };
}

export const HOURS = [
  { days: 'Lunes a jueves', hours: '16:00 — 00:00', accent: 'cyan' },
  { days: 'Viernes y vísperas', hours: '16:00 — 01:00', accent: 'coral' },
  { days: 'Sábados', hours: '12:00 — 02:00', accent: 'lime' },
  { days: 'Domingos y festivos', hours: '12:00 — 00:00', accent: 'violet' },
];

export const TICKET_GAMES = [
  {
    id: 'game-bowling',
    name: 'Bolos',
    answer: 'No consta',
    detail: 'La web oficial publica las tarifas de partidas, pero no menciona tickets.',
    tone: 'cyan',
  },
  {
    id: 'game-billiards',
    name: 'Billar',
    answer: 'Por confirmar',
    detail: 'No hay tarifa ni sistema de premios publicado online para esta actividad.',
    tone: 'lime',
  },
  {
    id: 'game-arcade',
    name: 'Arcade',
    answer: 'Por confirmar',
    detail: 'El tipo de máquina y si entrega tickets puede variar por juego.',
    tone: 'coral',
  },
  {
    id: 'game-kids',
    name: 'Zona kids',
    answer: 'Por confirmar',
    detail: 'El parque y sus condiciones requieren consulta de disponibilidad y protocolo.',
    tone: 'violet',
  },
];

export const REWARD_DRAFT = [
  { id: 'mini', name: 'Detalle mini', detail: 'premio de impulso', tickets: '100 tickets', tone: 'cyan' },
  { id: 'fan', name: 'Merch / recuerdo', detail: 'para llevártelo puesto', tickets: '250 tickets', tone: 'lime' },
  { id: 'plus', name: 'Premio destacado', detail: 'un extra para la revancha', tickets: '500 tickets', tone: 'coral' },
  { id: 'jackpot', name: 'Premio especial', detail: 'sujeto a stock del local', tickets: '1.000 tickets', tone: 'violet' },
];
